import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import { ChakraProvider } from '@chakra-ui/react';
import { useState, useEffect } from 'react';

import DashboardLayout from './layouts/Dashboard.js';
import LoaderLayout from './layouts/Loader.js';
import usePreloader from './hooks/usePreloader';
import { cars } from './views/Home/Models';

const queryClient = new QueryClient();

const App = () => {
  const filePaths = cars.map((car) => car.modelPath);
  const isLoading = usePreloader(filePaths);

  return (
    <ChakraProvider>
      <HashRouter>
        <QueryClientProvider client={queryClient}>
          <Switch>
            { isLoading ? (
                <Route path="/" component={LoaderLayout} />
              ) : (
                <Route path="/" component={DashboardLayout} />
              )
            }
          </Switch>
        </QueryClientProvider>
      </HashRouter>
    </ChakraProvider>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
